import React, { Component } from 'react'
import { StyleSheet, css } from 'aphrodite'
import {
  Breakpoints,
} from 'inno-components'
import chroma from 'chroma-js'
import Config from '../../Config'

const styles = StyleSheet.create({
  bold: {
    fontWeight: 'bold',
  },
  section: {
    padding: '2em 4em',
    [Breakpoints.small]: {
      padding: '1.5em 1.5em',
    },
  },
  sectionTop: {
    backgroundImage:
      'url(https://storage.googleapis.com/innobelge-websites.appspot.com/sites/stages-tennis/images/bg.jpg)',
    backgroundSize: 'cover',
  },
  sectionMiddle: {
    backgroundColor: Config.colors.thirdary,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  topBar: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '1.5em 0',
  },
  topBarContainer: {
    padding: '0.5em',
  },
  logo: {
    width: '150px',
    height: 'auto',
  },
  logoFacebook: {
    width: '35px',
    height: '35px',
    borderRadius: '50%',
  },
  logoWhatsapp:{
    width: '35px',
    height: '35px',
    float: 'left',
    border: '5px solid #022B47',
  },
  header: {
    maxWidth: '1000px',
    height: 'auto',
    margin: '4em',
    [Breakpoints.small]: {
      maxWidth: '350px',
      margin: '2em',
    },
  },
  contentWrapper: {
    maxWidth: '850px',
    margin: 'auto',
  },
  titre: {
    fontSize: '2em',
    margintop: '2em',
    color: Config.colors.primary,
  },
  soustitre: {
    fontSize: '1.5em',
    color: Config.colors.primary,
  },
  image: {
    width: '100%',
    height: 'auto',
    marginTop: '2em 3em',
  },
  images: {
    margin: '3em 0',
  },
  tuile: {
    display: 'block',
    maxWidth: '180px',
    width: '180px',
    height: 'auto',
    margin: 'auto',
  },
  tuile1: {
    display: 'block',
    maxWidth: '300px',
    width: '360px',
    height: 'auto',
    margin: 'auto',
  },
  description: {
    display: 'block',
    backgroundColor: '#fff',
    padding: '1em',
    borderRadius: '1em',
    marginTop: '1em',
    border: `solid 2px ${chroma('#9ec6fb')
      .alpha(0.6)
      .css()}`,
  },
  clubs: {
    margin: '2em 0',
  },
  cours: {
    display: 'block',
    textAlign: 'center',
  },
  coursImage: {
    maxWidth: '100px',
    height: 'auto',
    margin: 'auto',
  },
  coursTitre: {
    textTransform: 'uppercase',
    fontWeight: 'bold',
  },
  ul: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
  },
  footer: {
    color: '#fff',
    backgroundColor: Config.colors.primary,
  },
  highlight: {
    color: Config.colors.secondary,
    fontWeight: 'bold',
    fontSize: '1.1em',
  },
  lien: {
    color: '#fff',
    textDecoration: 'none',
  },
  lienPrimary: {
    color: '#000',
    fontWeight: 'bold',
    textDecoration: 'none',
  },
  buttonContainer: {
    display: 'flex',
    alignItems: 'center',
    justifycontent: 'center',
    marginBottom: '4em',
  },
  button: {
    backgroundColor: Config.colors.primary,
    color: Config.colors.secondary,
    padding: '1em',
    fontWeight: 'bold',
    [Breakpoints.small]: {
      padding: '0.7em',
    },
  },
  titreOrange: {
    color: Config.colors.secondary,
  },
  signature: {
    color: '#FFFFFF',
    textDecoration: 'none',
  },
  iconSignature: {
    color: '#FC0D1B',
  },
  bigQuestion: {
    fontSize: '1.8rem',
    marginTop: '25px',
    fontWeight: '600',
  },

})


const AdultStages = () => (
  <section className="adult-stages">
    <br /><hr />
    <h2 className={css(styles.titre)}>STAGES ADULTES</h2>

    <p>
      Nous organisons également des stages pour adultes pendant les vacances scolaires
      francophones.
    </p>
    <p>Voici les informations pratiques :</p>

    <h3 className={css(styles.bigQuestion)}>QUAND ?</h3>
    <p>Vacances scolaires francophones:</p>
    <h4>DATES STAGES 2026-2027</h4>

    <section>
      <h4>Congé d’automne (Toussaint 2026)</h4>
      <ul>
        <li>
          <strong>Stage Toussaint 1 :</strong> du lundi 19 au jeudi 22 octobre 2026
        </li>
        <li>
          <strong>Stage Toussaint 2 :</strong> du lundi 26 au jeudi 29 octobre 2026
        </li>
      </ul>
    </section>

    <section>
      <h4>Vacances d’hiver (Noël)</h4>
      <ul>
        <li>
          <strong>Stage Noël :</strong> du lundi 21 au mercredi 23 décembre 2026 (3 jours)
        </li>
        <li>
          <strong>Stage Nouvel an :</strong> du lundi 28 décembre au mercredi 30 décembre 2026 (3 jours)
        </li>
      </ul>
    </section>

    <section>
      <h4>Congé de détente (Carnaval)</h4>
      <ul>
        <li>
          <strong>Stage Carnaval 1 :</strong> du lundi 22 février au jeudi 25 février 2027
        </li>
        <li>
          <strong>Stage Carnaval 2 :</strong> du lundi 1er mars au jeudi 4 mars 2027
        </li>
      </ul>
    </section>

    <section>
      <h4>Vacances de printemps (Pâques)</h4>
      <ul>
        <li>
          <strong>Stage Pâques 1 :</strong> du lundi 26 avril au jeudi 29 avril 2027
        </li>
        <li>
          <strong>Stage Pâques 2 :</strong> du lundi 3 au jeudi 6 mai 2027 (4 jours malgré le jeudi de l’Ascension le 6/5)
        </li>
      </ul>
    </section>

    <section>
      <h4>Stages été 2027</h4>
      <ul>
        <li>
          <strong>Stage été 2 :</strong> du lundi 5 au jeudi 8 juillet 2027
        </li>
        <li>
          <strong>Stage été 3 :</strong> du lundi 12 au jeudi 15 juillet 2027
        </li>
        <li>
          <strong>Stage été 4 :</strong> du lundi 19 au jeudi 22 juillet 2027
        </li>
        <li>
          <strong>Stage été 5 :</strong> du lundi 26 au jeudi 29 juillet 2027
        </li>
        <li>
          <strong>Stage été 6 :</strong> du lundi 2 au jeudi 5 août 2027
        </li>
        <li>
          <strong>Stage été 7 :</strong> du lundi 9 au jeudi 12 août 2027
        </li>
        <li>
          <strong>Stage été 8 :</strong> du lundi 16 au jeudi 19 août 2027
        </li>
        <li>
          <strong>Stage été 9 :</strong> du lundi 23 au jeudi 26 août 2027
        </li>
      </ul>
    </section>

    <section>
      <h4>Stages septembre 2027</h4>
      <ul>
        <li>
          <strong>Stage septembre 1 :</strong> du lundi 30 août au jeudi 2 septembre 2027
        </li>
        <li>
          <strong>Stage septembre 2 :</strong> du lundi 6 au jeudi 9 septembre 2027
        </li>
        <li>
          <strong>Stage septembre 3 :</strong> du lundi 12 jeudi 16 septembre 2027
        </li>
      </ul>
    </section>

    <section>
      <h4>Congé d’automne (Toussaint 2027)</h4>
      <ul>
        <li>
          <strong>Stage Toussaint 1 :</strong> du lundi 25 au jeudi 28 octobre 2027
        </li>
        <li>
          <strong>Stage Toussaint 2 :</strong> du lundi 1er au jeudi 4 novembre 2027
        </li>
      </ul>
    </section>

    <h3 className={css(styles.bigQuestion)}>DUREE ET HORAIRE ?</h3>
    <p>
      6h/sem, du lundi au jeudi (1h30/jour).<br />
      Soit de <strong>19h à 20h30</strong> soit de <strong>20h30 à 22h</strong>.
    </p>

    <h3 className={css(styles.bigQuestion)}>SUR QUELS SITES ?</h3>
    <ul>
      <li>Royal Brussels Lawn Tennis Club</li>
      <li>Padel Tennis Club Montjoie</li>
      <li>Royal Wellington Tennis Club</li>
    </ul>

    <h3 className={css(styles.bigQuestion)}>PRIX ?</h3>
    <p><strong>150 euros/semaine</strong></p>

    <h3 className={css(styles.bigQuestion)}>Comment s’inscrire ?</h3>
    <p>
      Contactez <strong>Bruno Bloquet</strong>, reponsable stage adulte.<br />
      Tel ou Whatsapp : <a href="tel:+32478265203">0478/26.52.03</a>
    </p>
    <hr />
  </section>
);



export default AdultStages;